// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__bGBcq","iconWithCounter":"styles_iconWithCounter__i0_Pk","counterForLabel":"styles_counterForLabel__w7N31","counterForIcon":"styles_counterForIcon__Hp74q"};